import * as yup from 'yup';
import { aceite, declaracaoTipoRegime, tipoRegime } from './utils/rulesByKey';

export const RegimeTributarioSchema = yup.object({
  ...tipoRegime,
  ...aceite,
  ...declaracaoTipoRegime,
});

export const RegimeTributarioValues = {
  tipoRegime: '',
  declaracaoTipoRegime: false,
  aceite: false,
};
